import { createSelector } from 'reselect';
import type { RootState } from 'src/store';

const getSceneConfiguration = (state: RootState) => state.sceneConfiguration.activeLink;

const getSceneVariation = createSelector([getSceneConfiguration], (config) => config);

export default getSceneVariation;
